import { render, staticRenderFns } from "./newpaymentmethod.vue?vue&type=template&id=b22ba3c0&"
import script from "./newpaymentmethod.vue?vue&type=script&lang=js&"
export * from "./newpaymentmethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports